__turbopack_export_value__({
  "input": "Search-module-scss-module__loDisW__input",
  "search": "Search-module-scss-module__loDisW__search",
  "search__resetButton": "Search-module-scss-module__loDisW__search__resetButton",
  "search_focused": "Search-module-scss-module__loDisW__search_focused",
});
